import { types } from "mobx-state-tree"
import Checkpoint from './Checkpoint'

const Checkin = types.model('Checkin', {
    checkpoint_id: types.reference(Checkpoint),
    time_of_race: types.string,
})

export default Checkin
